<div id="loadingDiv" class="loadingDiv" style="display: none;">
    <img src="../../../assets/IMG/img_loader.png" width="150" height="100" alt="loading">
</div>
